import { Button, Stack } from "@mui/material";
import type { FormEventHandler } from "react";
import type { UseFormReturn } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { PortfolioFilterFormFields } from "web_myplann/Portfolio/Components/Redesign/Filter/PortfolioFilterFormFields";
import { StickyCtaBar } from "web_myplann/Shared/Components/Redesign/StickyCtaBar";

type Props = {
	form: UseFormReturn<FilterFormValues>;
	onSubmit: FormEventHandler<HTMLFormElement>;
};

export const PortfolioFilterForm = ({ form, onSubmit }: Props) => {
	const { t } = useResource();

	return (
		<Stack component="form" onSubmit={onSubmit}>
			<PortfolioFilterFormFields control={form.control} />

			<StickyCtaBar>
				<Button variant="primary" type="submit">
					{t(Resources.Portfolio.List.Redesign.Filter.apply)}
				</Button>
			</StickyCtaBar>
		</Stack>
	);
};
